
export function sortByWorks(disc) {
	const works = []
	disc.forEach(d => {
		if (works.length <= 0 || d.work !== works[works.length - 1].name) {
			works.push({ name: d.work, tracks: [d] })
		} else {
			works[works.length - 1].tracks.push(d)
		}
	})
	return works
}



// WEBPACK FOOTER //
// ./src/utils/filters.js